import { useEffect } from 'react';

import config from '../config';

const useOneTrustCookieBanner = () => {
  useEffect(() => {
    if (config.USE_ONETRUST_COOKIE_BANNER !== 'true') {
      return;
    }

    const reloadOTBanner = () => {
      const otConsentSdk = document.getElementById('onetrust-consent-sdk');
      if (otConsentSdk) {
        otConsentSdk.remove();
      }

      const oneTrust = window.OneTrust as any;
      if (oneTrust) {
        oneTrust.Init();

        setTimeout(() => {
          oneTrust.LoadBanner();

          const toggleDisplay = document.getElementsByClassName(
            'ot-sdk-show-settings'
          );
          Array.from(toggleDisplay).forEach((element) => {
            element.addEventListener('click', (event) => {
              event.stopImmediatePropagation();
              oneTrust.ToggleInfoDisplay();
            });
          });
        }, 1000);
      }
    };

    reloadOTBanner();
  }, []);

  return config.USE_ONETRUST_COOKIE_BANNER === 'true';
};

export default useOneTrustCookieBanner;
